export default "__VITE_ASSET__DBiYlQ4i__"